module.exports = __webpack_public_path__ + "static/media/year2022_1-sc.2384fcb8.jpg";